"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactJss = _interopRequireDefault(require("react-jss"));

var _classnames = _interopRequireDefault(require("classnames"));

var _ = require("../.");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const TextArea = ({
  name,
  value,
  placeholder,
  required,
  setValue,
  rows,
  min,
  classes
}) => _react.default.createElement("textarea", {
  className: (0, _classnames.default)(classes.textArea, 'form-input'),
  name: name,
  rows: rows,
  placeholder: placeholder,
  onChange: e => setValue(name, e.target.value, required, {
    min
  }),
  value: value
});

TextArea.defaultProps = {
  rows: 5
};
TextArea.propTypes = {
  name: _propTypes.default.string.isRequired,
  value: _propTypes.default.string,
  placeholder: _propTypes.default.node,
  required: _propTypes.default.bool,
  setValue: _propTypes.default.func.isRequired,
  rows: _propTypes.default.number,
  min: _propTypes.default.number
};

var _default = (0, _.withFormControl)((0, _reactJss.default)({
  textArea: {
    display: 'block',
    resize: 'vertical'
  }
})(TextArea));

exports.default = _default;